export default __webpack_public_path__ + "572f1984a0add724460f51e5f97f8d0b.png";